export * from '../../constants';

export const PROMO_CODE_URL_PARAM = '__promocode__';
export const PROMO_CODE_URL_PLACEHOLDER = '[promocode]';
